/** API route map: URLS.Controller.PayrollDeductionCode */
export const PayrollDeductionCode = {
      Name: 'PayrollDeductionCode/',
      Add: 'add',
      GetAll: 'get-all',
      Update: 'update',
      Delete: 'delete',
      SearchDeductionCode: 'search-deduction-code',
      AddAssignedDeductionCode: 'add-assigned-deduction-code',
      GetAssignedDeductionCodes: 'get-deduction-code-by-client-id',
      DeleteAssignedDeductionCode: 'delete-assigned-deduction-code',
      SearDeductionCodeByClientId: 'search-deduction-code-by-client-id',
      GetAllDeductionCode: 'get-all-deduction-codes',
      Import: 'import',
};
